import { useLanguage } from "@/components/LanguageContext";

const DiagonalMarquee = () => {
  const { t } = useLanguage();
  const items = [t.hero.l1 + " " + t.hero.l2, "Analysieren.", "Lösen.", "Wachsen."];

  const Row = ({ hidden = false }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {items.map((item, i) => (
        <span key={i} className="flex items-baseline">
          <span
            className={`whitespace-nowrap px-10 font-display text-5xl font-medium tracking-tight lg:text-7xl ${
              i % 2 === 0
                ? "text-bone"
                : "text-transparent"
            }`}
            style={i % 2 !== 0 ? { WebkitTextStroke: "1.5px rgba(61,158,255,0.85)" } : undefined}
          >
            {item}
          </span>
          <span className="h-2.5 w-2.5 rounded-full bg-gold" aria-hidden="true" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="diagonal-marquee" className="overflow-hidden py-10">
      <div className="rotate-[-1.5deg]">
        <div className="-mx-4 border-y border-bone/10 bg-dark2 py-8">
          <div className="marquee-track" style={{ animationDuration: "38s" }}>
            <Row />
            <Row hidden />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiagonalMarquee;
